import React from "react";
import TableLoader from "./TableLoader";

function CommonTableLoader() {
  return (
    <div className="valign-wrapper justify-center cover white">
      <TableLoader
        headerData={[
          "Auction ID",
          "Auction Region",
          "Description",
          "Date/Timings",
          "Catalogue status",
          "Action",
        ]}
      />
    </div>
  );
}

export default CommonTableLoader;
